import { Component, Input, output } from '@angular/core';
import { CollapsibleComponent } from '@/app/shared/collapsible/collapsible.component';
import { DesyAngularModule } from 'desy-angular';
import { ProtocolDetailsResponse } from '@/app/interfaces/protocol-details';
import { uppercaseAll } from '@/app/pipe/uppercaseAll.pipe';
import { UppercaseFirstLetterFirstWordPipe } from '@/app/pipe/uppercaseFirstLetterFirstWord.pipe';

@Component({
  selector: 'app-protocol-details',
  imports: [uppercaseAll, UppercaseFirstLetterFirstWordPipe, CollapsibleComponent, DesyAngularModule],
  templateUrl: './protocol-details.component.html',
})
export class ProtocolDetailsComponent {
  @Input() protocol: ProtocolDetailsResponse;

  dataChange = output<ProtocolDetailsResponse>();

  selectProtocol() {
    this.dataChange.emit(this.protocol);
  }
}
